import GalaxyTextSourceIcon from "../../assets/components/sources/GalaxyTextSourceIcon";

const GalaxyTextIcon = ({ height }: { height: number }) => {
  return <GalaxyTextSourceIcon height={height} />;
};

export default GalaxyTextIcon;
